import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppAuthGuard } from './utils/guards/auth.guard';
import { AuthComponent } from './auth/auth.component';
import { MenuTabComponent } from './components/menu-tab/menu-tab.component';
import { DaysListComponent } from './components/days-list/days-list.component';
import {
  ACCOUNT,
  ARCHIVED_REQUESTS,
  OPEN_REQUESTS,
  REQUESTS_IN_WORK
} from './utils/constants/router.constants';
import { DayDetailsComponent } from './components/days-list/day-details/day-details.component';
import { ExpeditorTermsComponent } from './components/expeditor-terms/expeditor-terms.component';
import { AccountPageComponent } from './components/account-page/account-page.component';
import { RegistrationComponent } from './auth/registration/registration.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { UserAgreementComponent } from './auth/registration/user-agreement/user-agreement.component';
import { DataProcessingTermsComponent } from './auth/registration/data-processing-terms/data-processing-terms.component';
import { BankingInformationComponent } from './components/banking-information/banking-information.component';
import { Status } from './dto/status.enum';
import { OrdersPageComponent } from './components/orders-page/orders-page.component';
import { NewCarComponent } from './components/days-list/day-details/new-car/new-car.component';
import { LoadCarComponent } from './components/days-list/day-details/load-car/load-car.component';
import { EndDayComponent } from './components/days-list/day-details/end-day/end-day.component';
import { EndOrderComponent } from './components/days-list/end-order/end-order.component';
import { OpenRequestInfoComponent } from './components/open-request-info/open-request-info';
import { FilePageComponent } from './components/file-page/file-page.component';
import { ImpersonationLoginComponent } from './components/impersonation-login/impersonation-login.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [AppAuthGuard],
    component: MenuTabComponent,
    children: [
      {
        path: '',
        redirectTo: OPEN_REQUESTS,
        pathMatch: 'full'
      },
      {
        path: OPEN_REQUESTS,
        children: [
          {
            path: '',
            component: OrdersPageComponent,
            data: {
              headerData: {
                statuses: [Status.OPEN],
                totalCount: 0,
                title: 'Заявки',
                tabRoute: OPEN_REQUESTS
              },
              ordersListData: {
                statuses: [Status.OPEN],
                searchTerms: []
              },
              tabName: OPEN_REQUESTS
            },
            runGuardsAndResolvers: 'always'
          },
          {
            path: 'days/:id',
            children: [{ path: '', component: OpenRequestInfoComponent }]
          }
        ]
      },
      {
        path: REQUESTS_IN_WORK,
        children: [
          {
            path: '',
            component: OrdersPageComponent,
            data: {
              headerData: {
                statuses: [Status.IN_WORK, Status.ACCEPTED],
                totalCount: 0,
                title: 'В работе',
                tabRoute: REQUESTS_IN_WORK
              },
              ordersListData: {
                statuses: [Status.IN_WORK, Status.ACCEPTED],
                searchTerms: []
              },
              tabName: REQUESTS_IN_WORK
            }
          },
          {
            path: 'days/:id',
            children: [
              { path: '', component: DaysListComponent },
              {
                path: 'files/:dealId',
                component: FilePageComponent
              },
              { path: 'end-order', component: EndOrderComponent },
              {
                path: 'day/:id',
                children: [
                  { path: '', component: DayDetailsComponent },
                  {
                    path: 'add-new-car',
                    component: NewCarComponent
                  },
                  {
                    path: 'load-car/:dayId/:vehicleId',
                    component: LoadCarComponent
                  },
                  {
                    path: 'end-day',
                    component: EndDayComponent
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        path: ARCHIVED_REQUESTS,
        children: [
          {
            path: '',
            component: OrdersPageComponent,
            data: {
              headerData: {
                statuses: [Status.COMPLETED, Status.CLOSED],
                totalCount: 0,
                title: 'Архив',
                tabRoute: ARCHIVED_REQUESTS
              },
              ordersListData: {
                statuses: [Status.CLOSED],
                searchTerms: []
              },
              tabName: ARCHIVED_REQUESTS
            }
          },
          {
            path: 'days/:id',
            children: [
              { path: '', component: DaysListComponent },
              {
                path: 'files/:dealId',
                component: FilePageComponent
              },
              {
                path: 'day/:id',
                children: [
                  { path: '', component: DayDetailsComponent },
                  {
                    path: 'load-car/:dayId/:vehicleId',
                    component: LoadCarComponent
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        path: ACCOUNT,
        component: AccountPageComponent
      }
    ]
  },
  {
    path: 'impersonation/callback',
    component: ImpersonationLoginComponent
  },
  { path: 'expeditorTerms', component: ExpeditorTermsComponent },
  { path: 'auth', canActivate: [AppAuthGuard], component: AuthComponent },
  { path: 'user-agreement', component: UserAgreementComponent },
  { path: 'data-processing-terms', component: DataProcessingTermsComponent },
  { path: 'registration', component: RegistrationComponent },
  { path: 'reset-password', component: ForgotPasswordComponent },
  { path: 'banking-data', component: BankingInformationComponent },
  { path: '**', redirectTo: OPEN_REQUESTS }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [AppAuthGuard]
})
export class AppRoutingModule {
}
